import { instance } from '../api/ApiRequest';
import { serverUrls } from '../variables';
import { statuses, types } from '../modules/ClientCommunication/constants/constants';
import { IMonthlyBoardResponse } from '../types/owner.types';

export const getMonthlyBoardEmailReports = async ({
  page = 1,
  column,
  fsm_ids,
  fsmsData,
  ownerName,
}: {
    page: number;
    column: string;
    fsm_ids: string[];
    fsmsData: { id: number; full_name: string }[];
    ownerName: string;
}) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    column,
  });

  if (fsm_ids.length !== fsmsData?.length && fsm_ids?.length) {
    queryParams.append("fsm_ids", fsm_ids.join(','));
  }

  if (Boolean(ownerName)) {
    queryParams.append("owner", ownerName);
  }

  return await instance.get<IMonthlyBoardResponse>(
    `${serverUrls.clientCommunication}emails/monthly-board/?${queryParams}`,
  );
};

export const getAllEmails = async ({
  page,
  status,
  type,
  fsm_ids,
  period,
  fsmsData,
  ownerName,
}: {
  page: any;
  status: string[];
  type: string[],
  fsm_ids: string[];
  period: any;
  fsmsData: { id: number; full_name: string }[];
  ownerName: string;
}) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
  });

  if (status.length !== statuses?.length && status?.length) {
    queryParams.append("status", status.join(","));
  }
  if (type.length !== types?.length && type?.length) {
    queryParams.append("type", type.join(","));
  }
  if (fsm_ids.length !== fsmsData?.length && fsm_ids?.length) {
    queryParams.append("fsm_ids", fsm_ids.join(","));
  }
  if (period !== "all_time") {
    queryParams.append("period", period);
  }
  if (Boolean(ownerName)) {
    queryParams.append("owner", ownerName);
  }

  const response = await instance.get(
    `${serverUrls.clientCommunication}emails/?${queryParams}`,
  );

  return response.data;
};

export const getFSMs = async () => {
  const response = await instance.get(`${serverUrls.clientCommunication}fsms/`);
  return response.data;
};

export const getEmailReportById = async (email_id: number  | null) => {
  const response = await instance.get(
    `${serverUrls.clientCommunication}emails/${email_id}/`,
  );

  return response.data;
};

export const skipEmail = async (email_id: number, payload: any) => {
  const response = await instance.post(
    `${serverUrls.clientCommunication}emails/${email_id}/skip/`,
    payload,
  );

  return response;
};

export const regenerateEmail = async (email_id: number) => {
  const response = await instance.post(
    `${serverUrls.clientCommunication}emails/${email_id}/regenerate/`,
  );

  return response;
};

export const sendEmail = async (email_id: number, payload: any) => {
  const response = await instance.post(
    `${serverUrls.clientCommunication}emails/${email_id}/send/`,
    payload,
  );

  return response;
};

export const getEmailsStatistics = async ({ period }: { period: any }) => {
  const queryParams = new URLSearchParams({
    ...(period === "all_time" ? {} : { period }),
  });
  const response = await instance.get(
    `${serverUrls.clientCommunication}emails/statistics/?${queryParams}`,
  );

  return response;
};

export const saveEditedEmail = async (email_id: number, payload: any) => {
  const response = await instance.patch(
    `${serverUrls.clientCommunication}emails/${email_id}/`,
    payload,
  );
  return response;
};

export const getSignature = async () => {
  const response = await instance.get(
    `${serverUrls.clientCommunication}my-signature/`,
  );

  return response;
};

export const refreshSignature = async (payload:any) => {
  const response = await instance.post(
    `${serverUrls.clientCommunication}my-signature/`,
    payload,
  );

  return response;
};
